import { c as _c } from "react/compiler-runtime";
import { type Post } from '@shared/all/domains/posts';
import { useEffect, useRef } from 'react';
import useDatabase from '../hooks/useDatabase';
import useDocumentVisible from './useDocumentVisible';
type UsePostEngagementTrackerOptions = {
  post: Post;
  externalIsInView: boolean;
  isFocused?: boolean;
};
const usePostEngagementTracker = t0 => {
  const $ = _c(15);
  const {
    post,
    externalIsInView,
    isFocused: t1
  } = t0;
  const isFocused = t1 === undefined ? true : t1;
  const {
    addOrUpdatePostEngagement,
    isReady,
    canWrite
  } = useDatabase();
  const isTabActive = useDocumentVisible();
  const intervalRef = useRef(null);
  let t2;
  if ($[0] !== addOrUpdatePostEngagement || $[1] !== canWrite || $[2] !== externalIsInView || $[3] !== isFocused || $[4] !== isReady || $[5] !== isTabActive || $[6] !== post) {
    t2 = () => {
      const isActive = externalIsInView && isFocused && isTabActive;
      if (isActive) {
        intervalRef.current = setInterval(() => {
          if (!post?.id) {
            return;
          }
          if (isReady && canWrite !== false) {
            addOrUpdatePostEngagement(post, 3, new Date());
          }
        }, 3000);
      } else {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
      }
      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
      };
    };
    $[0] = addOrUpdatePostEngagement;
    $[1] = canWrite;
    $[2] = externalIsInView;
    $[3] = isFocused;
    $[4] = isReady;
    $[5] = isTabActive;
    $[6] = post;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== canWrite || $[9] !== externalIsInView || $[10] !== isFocused || $[11] !== isReady || $[12] !== isTabActive || $[13] !== post) {
    t3 = [externalIsInView, isFocused, isTabActive, post, isReady, canWrite];
    $[8] = canWrite;
    $[9] = externalIsInView;
    $[10] = isFocused;
    $[11] = isReady;
    $[12] = isTabActive;
    $[13] = post;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  useEffect(t2, t3);
};
export default usePostEngagementTracker;